const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * User Notifications Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UserNotifications', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/v3/preferences/users/:subresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray:false}
  });

}]);

